import { render, staticRenderFns } from "./AddBank.vue?vue&type=template&id=65cc2ee4&scoped=true&"
import script from "./AddBank.vue?vue&type=script&lang=js&"
export * from "./AddBank.vue?vue&type=script&lang=js&"
import style0 from "./AddBank.vue?vue&type=style&index=0&id=65cc2ee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cc2ee4",
  null
  
)

export default component.exports